import { createFileRoute } from '@tanstack/react-router'
import { omit } from 'lodash-es'
import { useTranslation } from 'react-i18next'
import { EmployeeCard } from '@/entities/employee'
import { Offcanvas } from '@/entities/offcanvas'
import { useEmployeeItem } from '@/shared/api/employee'
import { useRouteOffcanvas } from '@/shared/hooks/use-route-offcanvas'

export const Route = createFileRoute('/_auth/users/employees/$employeeId')({
  component: RouteComponent,
})

function RouteComponent() {
  const { isOpen, close } = useRouteOffcanvas()
  const { t } = useTranslation()
  const { employeeId } = Route.useParams()
  const { data, isLoading, isError } = useEmployeeItem({ id: employeeId })
  return (
    <Offcanvas open={isOpen} onClose={close} title={t('Карточка сотрудника')}>
      <EmployeeCard
        avatarStatus={omit(data, 'employee')}
        employee={data?.employee}
        isLoading={isLoading}
        isError={isError}
      />
    </Offcanvas>
  )
}
